import React from 'react'
import { ContentHeader } from '../../../layout/Content'

function POHeader() { return ( <ContentHeader title='Purchase Order'/> ) }

export default React.memo(POHeader)
